import React, { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'store';
import CookieBanner from 'components/CookieBanner/CookieBanner';
import { useSystemSettings } from '../../providers/SystemSettingsProvider';

export interface ProtectedRouteProps {
  /**
   * Route to render
   */
  children: React.ReactNode;

  /**
   * If router outlet should be rendered for sub-routers
   */
  noOutlet?: boolean;

  /**
   * Route only accesible to reviewers
   */
  reviewerOnly?: boolean;

  /**
   * Allows unauthenticated access if set in settings
   */
  allowUnauthenticated?: boolean;
}

/**
 * Companion util-component for react-router that checks if user is logged in, and if not,
 * redirects the user to login page.
 */
const ProtectedRoute: FC<ProtectedRouteProps> = ({ children, noOutlet, reviewerOnly, allowUnauthenticated }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const userType = useSelector((state) => state.auth.user.user_type);
  const { unauthenticated_access } = useSystemSettings();

  if (!isLoggedIn) {
    if (!unauthenticated_access) {
      return <Navigate to="/login" />;
    }

    if (!allowUnauthenticated) {
      return <Navigate to="/login" />;
    }
  }

  if (!(reviewerOnly ? userType === 'RER' : true)) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <CookieBanner />
      {children}
      {!noOutlet && <Outlet />}
    </>
  );
};

export default ProtectedRoute;
